import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getLessonAttachments } from "@/api/kuizy"
import KnowledgeList from "@/components/lesson/KnowledgeList"
import UploadPanel from "@/components/lesson/UploadPanel"

export default function LessonManagePage() {
    const { lesson_id } = useParams()
    const [attachments, setAttachments] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        const { data } = await getLessonAttachments(lesson_id)
        setAttachments(data.data || [])
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [lesson_id])

    if (loading) return <div className="p-10">Loading...</div>

    return (
        <div className="p-10 grid grid-cols-3 gap-10">
            <div className="col-span-2">
                <KnowledgeList
                    attachments={attachments}
                    refresh={fetchData}
                />
            </div>

            <div>
                <UploadPanel lessonId={lesson_id} refresh={fetchData} />
            </div>
        </div>
    )
}
